module.exports = __webpack_public_path__ + "static/media/icon_extension_xls.b7ea755f.svg";